



















import Vue from 'vue';
import { BFormCheckbox, BFormGroup } from 'bootstrap-vue';

export default Vue.extend({
  name: 'InstantEmailNotifications',
  components: {
    BFormCheckbox,
    BFormGroup,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    update(newValue: Boolean) {
      this.$emit('input', newValue);
    },
  },
});
